<!-- SPDX-License-Identifier: AGPL-3.0-or-later -->

@for (match of sortedQualificationMatches; track match.id) {
  <app-qualification-match-line
    #matchLineElement
    [match]="match"
    (onMatchUpdate)="onMatchUpdate.emit($event)"
    (markTeamDrinksPickedUp)="triggerMarkTeamDrinksPickedUp(match, $event)"
    [tournamentId]="tournamentId()"
    [teams]="teamDtos()"
    [viewOnly]="viewOnly()"
    [disableMatchEdit]="disableMatchEdit()"
  ></app-qualification-match-line>
}
@if (qualificationMatches().length === 0 && showEmptyMessage()) {
  <div class="no-matches-container">
    @if (!viewOnly()) {
        <h1>Its empty here</h1>
        <h2>There are no matches generated for the qualification phase yet.</h2>
      <button
        (click)="generateQualificationMatches.emit()"
        mat-flat-button
        [color]="'primary'"
        data-cy="generate-qualification-matches-btn"
      >
        <mat-icon>settings_suggest</mat-icon>
        Generate matches
      </button>
    }
  </div>
}
